import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { PostHogPageView } from './analytics/PostHogPageView';
import Welcome from './components/Welcome';
import SignUp from './components/SignUp';
import Login from './components/Login';
import Verify from './components/Verify';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Home from './components/Home';
import OnboardingInitial from './components/OnboardingInitial';
import V2OnboardingAgent from './components/OnboardingAgent/V2OnboardingAgent';
import CareerShiftScenarioMap from './components/CareerShiftScenarioMap';
import Dashboard from './components/Dashboard';
import Terms from './components/Terms';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminCategories from './components/AdminCategories';
import AdminCategoryContents from './components/AdminCategoryContents';
import AdminUserCfpSessions from './components/AdminUserCfpSessions';
import ForecastPage from './components/dashboard/forecast/ForecastPage';
import YourQuickRichuelsPage from './components/dashboard/your-quick-richuels/YourQuickRichuelsPage';
import YourProgressPage from './components/dashboard/your-progress/YourProgressPage';
import ProgressSessionPage from './components/dashboard/your-progress/ProgressSessionPage';
import YourWeeklyWinsPage from './components/dashboard/YourWeeklyWinsPage';
import YourMonthlyWinsPage from './components/dashboard/YourMonthlyWinsPage';
import AssumptionsPage from './components/dashboard/AssumptionsPage';
import ExplorerPage from './components/dashboard/ExplorerPage';
import CommunityPage from './components/dashboard/CommunityPage';
import TalkToReesePage from './components/dashboard/TalkToReesePage';
import MeetAnExpertPage from './components/dashboard/MeetAnExpertPage';
import ScheduleCfpSessionPage from './components/dashboard/schedule-cfp-session/ScheduleCfpSessionPage';
import SettingsPage from './components/dashboard/SettingsPage';
import CopilotPage from './components/dashboard/CopilotPage';
import PreferencesPage from './components/PreferencesPage';
import AccountDeactivatedPage from './components/AccountDeactivatedPage';
import ContentReflectionProvider from './context/ContentReflectionProvider';
import ContentCatalogPrefetch from './components/ContentCatalogPrefetch';

function App() {
  return (
    <div className="App">
      <Router>
        <ContentReflectionProvider>
          <ContentCatalogPrefetch />
          <PostHogPageView />
          <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/home" element={<Home />} />
          <Route path="/onboarding-initial" element={<OnboardingInitial />} />
          <Route path="/v2-onboarding-agent" element={<V2OnboardingAgent />} />
          <Route
            path="/career-shift-scenario-map"
            element={<Navigate to="/dashboard/career-shift-scenario-map" replace />}
          />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<ForecastPage />} />
            <Route path="forecast" element={<ForecastPage />} />
            <Route path="copilot" element={<CopilotPage />} />
            <Route path="career-shift-scenario-map" element={<CareerShiftScenarioMap />} />
            <Route path="tracks/your-quick-richuels" element={<YourQuickRichuelsPage />} />
            <Route path="tracks/your-weekly-wins" element={<YourWeeklyWinsPage />} />
            <Route path="tracks/your-monthly-wins" element={<YourMonthlyWinsPage />} />
            <Route path="tracks/your-progress" element={<YourProgressPage />} />
            <Route path="tracks/your-progress/:sessionId" element={<ProgressSessionPage />} />
            <Route path="assumptions" element={<AssumptionsPage />} />
            <Route path="explorer" element={<ExplorerPage />} />
            <Route path="community" element={<CommunityPage />} />
            <Route path="chat" element={<TalkToReesePage />} />
            <Route path="meet-an-expert" element={<MeetAnExpertPage />} />
            <Route path="schedule-cfp-session" element={<ScheduleCfpSessionPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="/preferences" element={<PreferencesPage />} />
          <Route path="/account-deactivated" element={<AccountDeactivatedPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin-categories" element={<AdminCategories />} />
          <Route path="/admin-category-contents" element={<AdminCategoryContents />} />
          <Route path="/admin-user-cfp-sessions" element={<AdminUserCfpSessions />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ContentReflectionProvider>
      </Router>
    </div>
  );
}

export default App;
